import { IconType } from 'react-icons/lib';

const UpdateMapConversationIcon: React.FC<{ color?: string }> = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_26374_124542)">
      <path
        d="M2 21.0004C1.99992 19.4608 2.44413 17.9538 3.27935 16.6603C4.11456 15.3669 5.30527 14.3419 6.7086 13.7085C8.11193 13.075 9.66824 12.8599 11.1908 13.0891C12.7133 13.3183 13.3453 13.4815 14.5 14.5"
        stroke={color ?? 'white'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13C12.7614 13 15 10.7614 15 8C15 5.23858 12.7614 3 10 3C7.23858 3 5 5.23858 5 8C5 10.7614 7.23858 13 10 13Z"
        stroke={color ?? 'white'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.53 16.278V20.898C14.53 21.36 14.6437 21.7157 14.871 21.965C15.0983 22.2143 15.432 22.339 15.872 22.339C16.312 22.339 16.6493 22.2143 16.884 21.965C17.1187 21.7157 17.236 21.36 17.236 20.898V16.278H19.117V20.887C19.117 21.5763 18.9703 22.1593 18.677 22.636C18.3837 23.1127 17.9877 23.472 17.489 23.714C16.9977 23.956 16.4477 24.077 15.839 24.077C15.2303 24.077 14.684 23.9597 14.2 23.725C13.7233 23.483 13.3457 23.1237 13.067 22.647C12.7883 22.163 12.649 21.5763 12.649 20.887V16.278H14.53Z"
        fill={color ?? 'white'}
      />
    </g>
    <defs>
      <clipPath id="clip0_26374_124542">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const UpdateMapConversationModIcon: IconType = () => (
  <UpdateMapConversationIcon color="currentColor" />
);

export { UpdateMapConversationModIcon };
export default UpdateMapConversationIcon;
